import { ChangeEvent, useCallback } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'

type DebugCheckboxProps = {
    secondary?: boolean
    label: string
    checked: boolean
    onToggle: (checked: boolean) => void
}

export const DebugCheckbox = observer(({ secondary, label, checked, onToggle }: DebugCheckboxProps) => {
    const handleChange = useCallback(
        (evt: ChangeEvent<HTMLInputElement>) => {
            onToggle(evt.target.checked)
        },
        [onToggle]
    )

    return (
        <label className={classNames('flex items-center', { 'gap-x-2': !secondary, 'gap-x-1': secondary })}>
            <input
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                className={classNames('rounded', { 'h-4 w-4': !secondary, 'h-3 w-3': secondary })}
            />
            <span className={classNames({ 'text-xs font-medium text-neutral-500': secondary })}>{label}</span>
        </label>
    )
})
